import React from 'react';
import { arrayOf, object, oneOfType, shape, string } from 'prop-types';

import { getErrorMessage } from '../helpers/errors';

import classes from './ActionErrorList.module.css';

function formatError(errorItem) {
    if (typeof errorItem === 'string') {
        return errorItem;
    }
    if (errorItem.message) {
        return `${errorItem.name}: ${errorItem.message}`;
    }
    const { name } = errorItem.item;
    return `${name}: ${getErrorMessage(errorItem.error)}`;
}

const ActionErrorList = ({ errors }) => {
    if (errors && !Array.isArray(errors)) {
        errors = [errors];
    }
    if (!errors || !errors.length) {
        return null;
    }
    return (
        <aside className={classes.root}>
            <header className={classes.header}>
                The following errors have occurred:
            </header>
            <ul className={classes.errors}>
                {errors.map((errorItem, index) =>
                    <li key={index}>
                        {formatError(errorItem)}
                    </li>
                )}
            </ul>
        </aside>
    );
};

ActionErrorList.defaultProps = {
    errors: []
};

ActionErrorList.propTypes = {
    errors: oneOfType([
        string,
        arrayOf(
            oneOfType([
                string,
                shape({
                    error: object,
                    item:  shape({
                        name: string
                    })
                })
            ])
        )
    ])
};

export default ActionErrorList;
